import React from 'react';
import styled from 'styled-components';
import { Flex, Box, Text, Button } from 'rebass/styled-components';

const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  font-family: 'Sk-Modernist-Regular', sans-serif;
  background-color: white;
  display: flex;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 150px;
    background: linear-gradient(to top, white 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
    z-index: 2;
  }
`;

const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.15;
  z-index: 1;
`;

const ContentWrapper = styled(Box)`
  position: relative;
  z-index: 3;
  max-width: 1300px;
  width: 100%;
  margin: 0px auto;
  padding: 0 20px;
  padding-top: 200px;
`;

const Layout = styled(Flex)`
  gap: 60px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const BadgeColumn = styled(Box)`
  min-width: 320px;

  @media (max-width: 768px) {
    min-width: auto;
  }
`;

const ContentColumn = styled(Box)`
  max-width: 800px;
`;

const Badge = styled(Flex)`
  align-items: center;
  gap: 6px;
`;

const BadgeText = styled(Text)`
  color: #ff4f00;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
`;

const MainHeading = styled.h1`
  color: #ff4f00;
  font-weight: 400;
  line-height: 1.1;
  margin-bottom: 24px;
  font-size: 64px;

  @media (max-width: 1024px) {
    font-size: 48px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 30px;
  }
`;

const SubHeading = styled(Text)`
  color: #1a232e;
  font-size: 24px;
  line-height: 1.5;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const ButtonGroup = styled(Flex)`
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    align-items: flex-start;
  }
`;

const PrimaryButton = styled(Button)`
  background-color: #ff4f00;
  color: white;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  font-weight: 400;

  &:hover {
    opacity: 0.85;
  }
`;

const SecondaryButton = styled(Button)`
  background: transparent;
  color: #ff4f00;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  border: 1px solid #ff4f00;
  cursor: pointer;
  font-weight: 400;

  &:hover {
    background: #ff4f00;
    color: white;
  }
`;

const NHSLogoSection = styled(Flex)`
  align-items: center;

  img {
    height: 40px;
  }

  @media (max-width: 480px) {
    margin-top: 10px;
    img {
      height: 30px;
    }
  }
`;

const Hero = () => {
  return (
    <HeroContainer>
      <BackgroundImage src="/images/hero-img.png" alt="Pharmacy background" />

      <ContentWrapper>
        <Layout>
          {/* LEFT BADGE */}
          <BadgeColumn>
            <Badge>
              <div
                style={{
                  height: 6,
                  width: 6,
                  backgroundColor: '#ff5c35',
                  clipPath: 'polygon(0 100%, 100% 100%, 100% 0)',
                }}
              />
              <BadgeText>Repeat Prescription Service</BadgeText>
            </Badge>
          </BadgeColumn>

          {/* RIGHT CONTENT */}
          <ContentColumn>
            <MainHeading>Managing your medication should be simple.</MainHeading>

            <SubHeading>My Pharmacy helps you order, track and collect your repeat prescriptions with ease.</SubHeading>

            <ButtonGroup>
              <a href={`${process.env.GATSBY_WEB_APP_URL}/#/ways-to-register`}>
                <PrimaryButton>Register</PrimaryButton>
              </a>
              <a href={`${process.env.GATSBY_WEB_APP_URL}/#/login`}>
                <SecondaryButton>Log In</SecondaryButton>
              </a>

              <NHSLogoSection>
                <img src="/images/nhs-logo.svg" alt="NHS Logo" />
              </NHSLogoSection>
            </ButtonGroup>
          </ContentColumn>
        </Layout>
      </ContentWrapper>
    </HeroContainer>
  );
};

export default Hero;
